import AppErrorBoundaryFallback from '@/error-handling/fallbacks/App';
import * as Sentry from '@sentry/react';
import { Outlet } from '@tanstack/react-router';

export const FramelessShell = () => {
  return (
    <div className="h-screen overflow-x-hidden overflow-y-auto">
      <div className="flex flex-1 items-start pb-48">
        <Sentry.ErrorBoundary
          fallback={AppErrorBoundaryFallback}
          beforeCapture={(scope) => {
            scope.setTag('boundary', 'page-level');
          }}
          showDialog
        >
          <Outlet />
        </Sentry.ErrorBoundary>
      </div>
    </div>
  );
};
